var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreyCoffee(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300,
    xmlns: "http://www.w3.org/2000/svg",
    height: 300,
    id: "screenshot-9980306d-f99b-8007-8002-8e8d60ccf32e",
    viewBox: "0 0 300 300",
    style: {
      WebkitPrintColorAdjust: "exact"
    },
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-9980306d-f99b-8007-8002-8e8d60ccf32e",
    height: 48,
    width: 48,
    rx: 0,
    ry: 0,
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-9980306d-f99b-8007-8002-8e8d60ccf330"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-9980306d-f99b-8007-8002-8e8d60ccf330"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M138.125,224.375C114.167,224.375,93.490,215.885,76.094,198.906C58.698,181.927,50.000,161.771,50.000,138.438L50.000,56.250C50.000,51.250,51.875,46.875,55.625,43.125C59.375,39.375,63.750,37.500,68.750,37.500L234.063,37.500C245.369,37.500,255.019,41.354,263.011,49.063C271.004,56.771,275.000,66.250,275.000,77.500C275.000,88.750,271.004,98.229,263.011,105.938C255.019,113.646,245.369,117.500,234.063,117.500L226.250,117.500L226.250,138.438C226.250,161.771,217.552,181.927,200.156,198.906C182.760,215.885,162.083,224.375,138.125,224.375ZL138.125,224.375ZM68.750,98.750L207.500,98.750L207.500,56.250L68.750,56.250L68.750,98.750ZL68.750,98.750ZM226.250,98.750L234.063,98.750C240.104,98.750,245.313,96.719,249.688,92.656C254.063,88.594,256.250,83.542,256.250,77.500C256.250,71.458,254.063,66.406,249.688,62.344C245.313,58.281,240.104,56.250,234.063,56.250L226.250,56.250L226.250,98.750ZL226.250,98.750ZM50.000,262.500L50.000,243.750L248.125,243.750L248.125,262.500L50.000,262.500ZL50.000,262.500ZM138.125,117.500L138.125,117.500Z",
    style: {
      fill: "rgb(87, 107, 124)",
      fillOpacity: 1
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyCoffee);
export default __webpack_public_path__ + "static/media/grey_coffee.be354a6efd5168492d1d21e4aa6352a0.svg";
export { ForwardRef as ReactComponent };